import React, {FormEvent, useEffect, useRef, useState} from "react";
import {Button, Form} from "react-bootstrap";
import LoaderHorizontal from "../../Common/LoaderHorizontal";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {
    setAllowCheckPaymentDone,
    setEmail,
    setIsPreviewPlaying,
    setSavedProjectPaymentDone
} from "../../../store/makerDataSlice";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../../Utils/defaults";
import Preview from "./Preview";
import {loaderCircleImage} from "../../../Utils/embedImages";
import promoCodeApply from "../../../Api/promoCodeApply";
import ym from "react-yandex-metrika";
import * as Sentry from "@sentry/react";
import saveProject2 from "../../../Api/saveProject2";
import {ErrorBoundary} from "../../Common/ErrorBoundary";
import {useMutation} from "@tanstack/react-query";
import axios from "axios";
import {UploadStatus} from "../../../Interfaces/SlideData";
import Loader from "../../Common/Loader";
import bridge from "@vkontakte/vk-bridge";
import {vkTerms} from "../../../Api/url";
import {captureException} from "@sentry/react";
import checkPaymentDone from "../../../Api/checkPaymentDone";
import {store} from "../../../store/store";
import {MAX_SLIDES} from "../../../Utils/maxSlides";
import {THEMES_FULL_PREVIEW} from "../../../Api/getPreviewStatus";

var pluralize = require('pluralize-ru');

var isTouchDevice = require('is-touch-device');

interface PaymentProps {
    isVisible: boolean,
    onGotoSlidesTab: () => void,
    onGotoMyVideoTab: () => void
}

const Payment: React.FC<PaymentProps> = ({
                                             isVisible,
                                             onGotoSlidesTab,
                                             onGotoMyVideoTab
                                         }) => {

    const emailInputRef = useRef<HTMLInputElement>(null);
    const promoCodeInputRef = useRef<HTMLInputElement>(null);
    const [paymentFromHtml, setPaymentFromHtml] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isPromoCodeLoading, setIsPromoCodeLoading] = useState<boolean>(false);
    const [promoCode, setPromoCode] = useState<string>('');
    const [promoCodeTimeout, setPromoCodeTimeout] = useState<any>();
    const [vkTermsChecked, setVkTermsChecked] = useState<boolean>(false);

    const makerData = useAppSelector(state => state.makerData)
    const previewData = useAppSelector(state => state.makerData.previewData)
    const dispatch = useAppDispatch();

    const mutationSaveProject2 = useMutation({
        mutationFn: saveProject2,
        onSuccess: (result) => {
            if (result === false) {
                setIsLoading(false);
            } else {
                if (result?.result === 'ok_2') {
                    setTimeout(() => window.location.href = result?.showUrl, 200);
                } else {
                    // успешное сохранение проекта
                    if (result?.price > 0) {
                        ym('reachGoal', 'yandexKassa_form_submit');
                        /* событие для пикселя VK рекламы */
                        /** @ts-ignore */
                        if (typeof _tmr !== "undefined") {
                            /** @ts-ignore */
                            _tmr.push({
                                type: 'reachGoal',
                                id: 3579110,
                                value: '' + result?.price,
                                goal: 'pay_form_submit',
                                params: {product_id: '1'}
                            });
                        }
                        if (typeof result?.tinkoffPaymentForm !== 'undefined') {
                            setPaymentFromHtml(result?.tinkoffPaymentForm);
                            // открываем popup с tinkoff pay
                            // @ts-ignore
                            window.pay(document.getElementsByClassName('payment-form-container')[0].getElementsByTagName('form')[0]);
                        } else if (typeof result?.tinkoffPaymentUrl !== 'undefined') {
                            // делаем редирект на страницу оплаты Тинькофф
                            setTimeout(() => window.location.href = result?.tinkoffPaymentUrl, 200);

                            if (makerData.vkLaunchParams?.vk_platform == 'mobile_ipad' || makerData.vkLaunchParams?.vk_platform == 'mobile_iphone' || makerData.vkLaunchParams?.vk_platform == 'mobile_android') {
                                // через приложение VK на android и iphone сразу выключаем isLoading, т.к. форма для оплаты открывается в отдельном браузере
                                // и если вернуться из него обратно - то кнопка так и будет loading и это событие (возврат) мы никак не может поймать
                                setIsLoading(false);
                            }
                            if (makerData?.vkLaunchParams?.vk_app_id && !makerData.savedProjectPaymentDone) {
                                // если запускается внутри VK - для приложений в Android и IPhone нужно принудительно проверять,
                                // оплачен ли проект, т.к. оплата открывается в отдельном браузере, а не внутри приложения vk
                                dispatch(setAllowCheckPaymentDone(true));
                                // здесь используем store напрямую, т.к. внутри useMutation не работает makerData из контекста component'а, не обновляется значение
                                const makerData2 = store.getState().makerData;
                                checkPaymentDone(makerData2.savedProjectData, dispatch, 0);
                            }
                        } else if (typeof result?.yandexKassaConfirmationToken !== 'undefined') {
                            dispatch(setIsPreviewPlaying(false));
                            let customization = {
                                modal: true,
                            };
                            // из-за того, что внутри VK приложение запускается через IFrame - другие способы оплаты (СБП и т.д., которые открывают приложение в телефоне) - не работают
                            // НЕ РАБОТАЕТ ЭТОТ ПАРАМЕТР - ОТВЕТ ПОДДЕРЖКИ Яндекс Кассы
                            // if (makerData?.vkLaunchParams?.vk_platform == 'mobile_web') {
                            //     // @ts-ignore
                            //     customization['payment_methods'] = ['bank_card'];
                            // }
                            // @ts-ignore
                            const checkout = new window.YooMoneyCheckoutWidget({
                                confirmation_token: result?.yandexKassaConfirmationToken,
                                customization: customization,
                                error_callback: function (error: any) {
                                    //Обработка ошибок инициализации
                                }
                            });
                            checkout.on('success', () => {
                                dispatch(setSavedProjectPaymentDone(true));
                                setIsLoading(false);
                                checkout.destroy();
                            });

                            checkout.on('fail', () => {
                                setIsLoading(false);
                                checkout.destroy();
                            });
                            checkout.on('modal_close', () => {
                                setIsLoading(false);
                            });
                            checkout.render();
                        } else if (typeof result?.vkGolosPaymentItem !== 'undefined') {
                            // Оплата голосами Вконтакте
                            bridge.send('VKWebAppShowOrderBox', {
                                type: 'item',
                                item: result?.vkGolosPaymentItem
                            })
                                .then((data) => {
                                    // @ts-ignore
                                    if (data.success) {
                                        onGotoMyVideoTab();
                                        dispatch(setSavedProjectPaymentDone(true));
                                        // Оплата голосами прошла успешно
                                        // const MySwal = withReactContent(Swal);
                                        // MySwal.fire({
                                        //     ...SWAL_DEFAULTS,
                                        //     customClass: {
                                        //         container: 'sl-swal sl-swal-vk-allow-notifications'
                                        //     },
                                        //     title: "Успешная оплата",
                                        //     icon: "success",
                                        //     html: <Provider store={store}>
                                        //         <p className={'text'}>Видео слайд шоу успешно оплачено, мы уже начали его делать.</p>
                                        //         <p className={'text'}>Разрешите нам прислать уведомление о готовности видео.</p>
                                        //         <Button
                                        //             className={'vk-allow-notifications-button'}
                                        //             onClick={() => {
                                        //                 bridge.send('VKWebAppAllowNotifications')
                                        //                     .then((data) => {
                                        //                         if (data.result) {
                                        //                             // Разрешение на отправку уведомлений мини-приложением или игрой получено
                                        //                             MySwal.close();
                                        //                         } else {
                                        //                             // Ошибка
                                        //                             MySwal.close();
                                        //                         }
                                        //                     })
                                        //                     .catch((error) => {
                                        //                         Sentry.captureException(error);
                                        //                     });
                                        //             }}>
                                        //             Разрешить
                                        //         </Button>
                                        //     </Provider>,
                                        // })
                                    }
                                    setIsLoading(false);
                                })
                                .catch((error) => {
                                    setIsLoading(false);
                                    // Sentry.captureException(error);
                                    // const MySwal = withReactContent(Swal);
                                    // MySwal.fire({
                                    //     ...SWAL_ALERT_DEFAULTS,
                                    //     title: 'Ошибка',
                                    //     text: 'Произошла ошибка при оплате. Попробуйте ещё раз.',
                                    //     icon: 'error'
                                    // });
                                });
                        } else {
                            Sentry.captureException(
                                new Error('Payment FORM or URL is empty.'),
                                {
                                    extra: {
                                        saveResult: result
                                    }
                                }
                            );
                            const MySwal = withReactContent(Swal);
                            MySwal.fire({
                                ...SWAL_ALERT_DEFAULTS,
                                title: 'Ошибка',
                                text: 'Ошибка при сохранении проекта. Попробуйте ещё раз.',
                                icon: 'error'
                            });
                            setIsLoading(false);
                        }
                    }
                }
            }
        },
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to save project 2. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: 'Ошибка',
                text: 'Ошибка при сохранении проекта. Попробуйте ещё раз.',
                icon: 'error'
            });
            setIsLoading(false);
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const mutationPromoCodeApply = useMutation({
        mutationFn: promoCodeApply,
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to apply promo code. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: 'Ошибка',
                text: 'Не удалось применить промо-код. Попробуйте ввести его ещё раз.',
                icon: 'error'
            });
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    // useEffect(() => {
    //     if (isVisible && !isTouchDevice()) {
    //         emailInputRef.current?.focus();
    //     }
    // });

    // После нажатия на кнопку "Оплатить", показывается загрузчик и переход в Тинькофф
    // Если из Тинькова нажать на кнопку "Назад" - то загрузчик на кнопке "Оплатить" не пропадает
    // и невозможно ещё раз на неё нажать.
    // Подписываемся на событие window.pageshow, в нём обнуляем isLoading, чтобы не показывался
    // загрузчик при переходе по кнопке "Назад" из Тинькова
    const pageShowPayment = () => {
        setIsLoading(false);
        dispatch(setIsPreviewPlaying(false));
    }
    useEffect(() => {
        window.addEventListener("pageshow", pageShowPayment);
        return () => {
            window.removeEventListener("pageshow", pageShowPayment);
        }
    }, []);
    // END

    useEffect(() => {
        if (makerData.promoCodeResponse !== null) {
            const MySwal = withReactContent(Swal);

            if (makerData.promoCodeResponse?.result == 'ok') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Промокод успешно активирован!',
                    text: 'Ваша скидка на видео: ' + makerData.promoCodeDiscount + '%',
                    icon: 'success'
                });
                ym('reachGoal', 'promoCode_activateSuccess');
            } else if (makerData.promoCodeResponse?.result == 'dateStart') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Ошибка',
                    html: 'Промокод начнёт действовать <b>' + makerData.promoCodeResponse?.dateStart + '</b>.<br><br>Попробуйте указать другой промокод.',
                    icon: 'error'
                });
                ym('reachGoal', 'promoCode_activateFailed');
            } else if (makerData.promoCodeResponse?.result == 'outdated') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Ошибка',
                    html: 'Срок действия промокода закончился.<br><br>Попробуйте указать другой промокод.',
                    icon: 'error'
                });
                ym('reachGoal', 'promoCode_activateFailed');
            } else if (makerData.promoCodeResponse?.result == 'used') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Ошибка',
                    html: 'Данный промокод уже использован.<br><br>Попробуйте указать другой промокод.',
                    icon: 'error'
                });
                ym('reachGoal', 'promoCode_activateFailed');
            } else if (makerData.promoCodeResponse?.result == 'theme') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Ошибка',
                    html: 'Данный промокод может быть использован только для темы <b>' + makerData.promoCodeResponse?.themeStr + '</b>.<br><br>Попробуйте указать другой промокод.',
                    icon: 'error'
                });
                ym('reachGoal', 'promoCode_activateFailed');
            } else if (makerData.promoCodeResponse?.result == 'maxSlides') {
                MySwal.fire({
                    ...SWAL_ALERT_DEFAULTS,
                    title: 'Ошибка',
                    html: 'Данный промокод может быть использован только для видео из  <b>' + makerData.promoCodeResponse?.maxSlides + '</b> слайдов или меньше.<br><br>Попробуйте указать другой промокод.',
                    icon: 'error'
                });
                ym('reachGoal', 'promoCode_activateFailed');
            } else if (makerData.promoCodeResponse?.result == 'none') {
                // MySwal.fire({
                //     ...SWAL_ALERT_DEFAULTS,
                //     title: 'Ошибка',
                //     html: 'Промокод не найден.<br><br>Попробуйте указать другой промокод.',
                //     icon: 'error'
                // });
                // ym('reachGoal', 'promoCode_activateFailed');
            } else {
                Sentry.captureException(
                    new Error('Failed to apply promoCode. Payment.'),
                    {
                        extra: {
                            promoCodeResponse: makerData.promoCodeResponse
                        }
                    }
                )
            }
        }
    }, [makerData.promoCodeResponse, makerData.promoCodeDiscount]);

    const applyPromoCode = async (promoCodeLocal: string) => {
        setPromoCode(promoCodeLocal);
        if (promoCodeTimeout) clearTimeout(promoCodeTimeout);
        setPromoCodeTimeout(
            setTimeout(async () => {
                setIsPromoCodeLoading(true);
                // sleep 2 sec
                await new Promise(r => setTimeout(r, 2500));
                mutationPromoCodeApply.mutate({
                    promoCode: promoCodeLocal,
                    themeId: makerData.currentTheme.themeId,
                    slidesNum: makerData.slidesNumReady,
                    dispatch: dispatch,
                    makerData: makerData
                })
                setIsPromoCodeLoading(false);
            }, 1000)
        );
    }

    const onPromoCodeSubmit = (e: FormEvent) => {
        e.preventDefault();
        applyPromoCode(promoCode);
    }

    const openPopupHowGetDiscount = () => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            ...SWAL_ALERT_DEFAULTS,
            customClass: {
                container: 'sl-swal-alert how-get-discount'
            },
            title: 'Как получить промокод на скидку:',
            html: 'Для получения скидки 25%, <br>вступите в <a href="https://vk.com/slide_life_ru" target="_blank">нашу группу ВКонтакте</a>, <br>затем напишите нам <b>сообщение</b> с секретным словом "Слайд-шоу".',
        });
        ym('reachGoal', 'promoCode_openHowToGet');
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();


        // ЮКасса checkout.js - попытка интеграции, запросил у поддержки, чтобы включили токенизацию платежа
        // try {
        //     // @ts-ignore
        //     const checkout = YooMoneyCheckout(56085);
        //     checkout.tokenize({
        //         number: '1',
        //         cvc: '1',
        //         month: '1',
        //         year: '1'
        //         // @ts-ignore
        //     }).then(response => {
        //         if (response.status === 'success') {
        //             const {paymentToken} = response.data.response;
        //
        //             return paymentToken;
        //         }
        //         if (response.status === 'error') {
        //             captureException(
        //                 new Error('Failed to tokenize payment data'),
        //                 {
        //                     extra: {
        //                         response: JSON.stringify(response)
        //                     }
        //                 }
        //             )
        //             return 'error';
        //         }
        //         console.log(response);
        //     });
        // } catch (error) {
        //     captureException(
        //         new Error('Failed to init checkout'),
        //         {
        //             extra: {
        //                 response: JSON.stringify(error)
        //             }
        //         }
        //     )
        //     console.log(error);
        // }
        //
        //
        // return;

        // if (makerData.vkLaunchParams?.vk_platform == 'mobile_ipad' || makerData.vkLaunchParams?.vk_platform == 'mobile_iphone' || makerData.vkLaunchParams?.vk_platform == 'mobile_android') {
        //     const MySwal = withReactContent(Swal);
        //     MySwal.fire({
        //         ...SWAL_DEFAULTS,
        //         customClass: {
        //             container: 'sl-swal'
        //         },
        //         title: "Ограничение на оплату",
        //         icon: "info",
        //         html: <div>
        //                 <p className={'preview-header'}>
        //                     Из-за ограничений в платформе ВК для <b>устройств на iOS и Android</b>, оплата полного видео невозможна.
        //                 </p>
        //                 <p className={'preview-header'}>
        //                     Для оплаты полного видео, <b>скопируйте ссылку</b> и откройте её <b>в браузере</b>.
        //                 </p>
        //                 <input type={'text'} className={'vk-preview-redirect'} value={'https://m.vk.com/app51650677#vk-preview-redirect-' + makerData.previewId} style={{width: '100%'}}/>
        //                 <br/>
        //                 <br/>
        //                 <Button
        //                     size={"sm"}
        //                     onClick={() => {
        //                         // @ts-ignore
        //                         document.getElementsByClassName('vk-preview-redirect')[0].select();
        //                         document.execCommand('copy');
        //                     }}>
        //                     скопировать ссылку
        //                 </Button>
        //             </div>,
        //     });
        //     return;
        // }

        if (isLoading) {
            return;
        }

        if (makerData.vkLaunchParams?.vk_app_id && !vkTermsChecked) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: '',
                text: 'Необходимо принять пользовательское соглашение',
                icon: 'info'
            });
            return;
        }

        setIsLoading(true);
        mutationSaveProject2.mutate({
            makerData: makerData,
            dispatch: dispatch
        })
    }

    let numSidesUploading = makerData.slides.filter(s => s.status === UploadStatus.uploading).length;
    if (typeof numSidesUploading === 'undefined') {
        numSidesUploading = 0;
    }

    return (
        <div className={'payment-container'}>
            {
                makerData.isAllPhotosUploaded && makerData.isAllMusicUploaded ?
                    (
                        <div>
                            {
                                makerData.slidesNumReady >= 2 && makerData.slidesNumReady <= MAX_SLIDES ?
                                    (
                                        <div>
                                            <div className="row justify-content-center">
                                                <div className={'col-md-6'}>
                                                    <p className={'preview-header'}>
                                                        {
                                                            THEMES_FULL_PREVIEW.includes(makerData.themes[makerData.themes.findIndex(s => s.isActive === true)]?.themeId) ?
                                                                'Макет видео в низком качестве:' :
                                                                'Макет видео, первые 5 слайдов в низком качестве:'
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={'row justify-content-center'}>
                                                <ErrorBoundary
                                                    place={'Payment-Preview'}
                                                    key={makerData.previewId}>
                                                    <Preview
                                                        openPopupHowGetDiscount={openPopupHowGetDiscount}
                                                        onGotoSlidesTab={onGotoSlidesTab}
                                                    />
                                                </ErrorBoundary>
                                            </div>
                                            {
                                                makerData.savedProjectPaymentDone ?
                                                    (
                                                        <div className={'payment-block'}>
                                                            <div className={'row justify-content-center'}>
                                                                <div className={'col-md-6'}>
                                                                    <p className={'preview-header'}>Полное видео, в
                                                                                                    качестве FullHD:</p>
                                                                    {
                                                                        makerData.vkLaunchParams?.vk_app_id ?
                                                                            <p>
                                                                                Полное видео успешно оплачено, оно будет
                                                                                доступно в разделе "Мои видео".
                                                                                <br/>
                                                                                <Button
                                                                                    size={"sm"}
                                                                                    onClick={onGotoMyVideoTab}>
                                                                                    Мои видео
                                                                                </Button>
                                                                            </p>
                                                                            :
                                                                            <p>Полное видео успешно оплачено, оно будет
                                                                               доступно
                                                                               по ссылке:<br/>
                                                                                {/* @ts-ignore */}
                                                                                <a href={makerData?.savedProjectData?.showUrl}
                                                                                   target={'_blank'}>{makerData?.savedProjectData?.showUrl}</a>
                                                                            </p>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    :
                                                    previewData !== null
                                                        ?
                                                        (
                                                            <div className={'payment-block'}>
                                                                <div className={'row justify-content-center'}>
                                                                    <div className={'col-md-6'}>
                                                                        {
                                                                            THEMES_FULL_PREVIEW.includes(makerData.themes[makerData.themes.findIndex(s => s.isActive === true)]?.themeId) ?
                                                                                <p className={'preview-header'}>
                                                                                    Полное видео, в наилучшем качестве FullHD:
                                                                                </p>
                                                                                :
                                                                                <p className={'preview-header'}>
                                                                                    Полное видео,
                                                                                    все {makerData.slidesNumReady} {pluralize(makerData.slidesNumReady, 'слайдов', 'слайд', 'слайда', 'слайдов')} в
                                                                                    качестве FullHD:
                                                                                </p>
                                                                        }
                                                                        {
                                                                            makerData.fullVideoMakeTimeStr ?
                                                                                <p>
                                                                                Полное видео будет готово примерно
                                                                                    через <b>{makerData.fullVideoMakeTimeStr}</b> после
                                                                                    оплаты.<br/>После этого его можно
                                                                                    будет скачать.
                                                                                </p> : ''
                                                                        }
                                                                        {
                                                                            makerData.fullVideoPrice ?
                                                                                <div className={'price-block'}>
                                                                                    <p className={'price'}>
                                                                                        Стоимость: <b>{(Math.ceil(makerData.fullVideoPrice * (100 - makerData.promoCodeDiscount) / 100))} руб.</b>
                                                                                    </p>
                                                                                    {
                                                                                        makerData.vkLaunchParams?.vk_app_id ? ''
                                                                                            :
                                                                                            <span>
                                                                                <Form
                                                                                    className={'promo-code-form'}
                                                                                    onSubmit={onPromoCodeSubmit}>
                                                                                    <Form.Group className="mb-3"
                                                                                                controlId="formBasicPromoCode">
                                                                                        <Form.Control
                                                                                            ref={promoCodeInputRef}
                                                                                            type="text"
                                                                                            placeholder="Промо-код"
                                                                                            disabled={isPromoCodeLoading || isLoading}
                                                                                            onChange={e => {
                                                                                                applyPromoCode(e.target.value);
                                                                                            }}
                                                                                            autoComplete={'off'}
                                                                                        />
                                                                                    </Form.Group>
                                                                                </Form>
                                                                                                {
                                                                                                    isPromoCodeLoading ?
                                                                                                        <img
                                                                                                            className={'promo-loader'}
                                                                                                            src={loaderCircleImage}/> : ''
                                                                                                }
                                                                                                <span
                                                                                                    className={'promo-code-how-to'}
                                                                                                    onClick={() => {
                                                                                                        openPopupHowGetDiscount()
                                                                                                    }}
                                                                                                >
                                                        Как получить скидку 25%
                                                    </span>
                                                                            </span>
                                                                                    }
                                                                                </div> : ''
                                                                        }
                                                                        {
                                                                            makerData.vkLaunchParams?.vk_app_id ?
                                                                                <div>
                                                                                    <Form.Check className="">
                                                                                        <Form.Check.Input
                                                                                            checked={vkTermsChecked}
                                                                                            onChange={() => setVkTermsChecked(!vkTermsChecked)}
                                                                                        />
                                                                                        <Form.Check.Label>Принимаю <span
                                                                                            className={'vk-terms-checkbox'}
                                                                                            onClick={() => {
                                                                                                fetch(vkTerms).then(response => response.text()).then(function (data) {
                                                                                                    const MySwal = withReactContent(Swal);
                                                                                                    MySwal.fire({
                                                                                                        ...SWAL_ALERT_DEFAULTS,
                                                                                                        customClass: {
                                                                                                            container: 'sl-swal sl-swal-vk-terms-popup'
                                                                                                        },
                                                                                                        title: '',
                                                                                                        html: data,
                                                                                                        showConfirmButton: false
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                            }>пользовательское соглашение</span>
                                                                                        </Form.Check.Label>
                                                                                    </Form.Check>
                                                                                </div> : ''
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={'row justify-content-center'}>
                                                                    <div className={'col-md-6'}>
                                                                        {
                                                                            makerData.vkLaunchParams?.vk_app_id ?
                                                                                (
                                                                                    <div className={'email-form-block'}>
                                                                                        <Form
                                                                                            className={'email-form'}
                                                                                            onSubmit={onSubmit}>
                                                                                            <Button
                                                                                                variant="primary btn-lg btn-block"
                                                                                                type="submit"
                                                                                                disabled={isLoading}
                                                                                            >
                                                                                                {isLoading ?
                                                                                                    <LoaderHorizontal/> : 'Сделать полное видео!'}
                                                                                            </Button>
                                                                                        </Form>

                                                                                        <div className={'payment-form-container'}
                                                                                             dangerouslySetInnerHTML={{__html: paymentFromHtml}}
                                                                                        ></div>

                                                                                    </div>
                                                                                )
                                                                                :
                                                                                (
                                                                                    <div className={'email-form-block'}>
                                                                                        <Form
                                                                                            className={'email-form'}
                                                                                            onSubmit={onSubmit}>
                                                                                            <Form.Group className="mb-3"
                                                                                                        controlId="formBasicEmail">
                                                                                                <Form.Label>Укажите свой
                                                                                                            Email:</Form.Label>
                                                                                                <Form.Control
                                                                                                    required
                                                                                                    ref={emailInputRef}
                                                                                                    type="email"
                                                                                                    placeholder="ivan@mail.ru"
                                                                                                    disabled={isLoading}
                                                                                                    onChange={e => {
                                                                                                        // @ts-ignore
                                                                                                        // Sentry.setUser({id: makerData.userId, email: e.target.value})
                                                                                                        dispatch(setEmail(e.target.value))
                                                                                                    }
                                                                                                    }
                                                                                                />
                                                                                                <Form.Text className="text-muted">
                                                                                                    На него придёт
                                                                                                    ссылка для
                                                                                                    скачивания
                                                                                                </Form.Text>
                                                                                            </Form.Group>
                                                                                            <Button
                                                                                                variant="primary btn-lg btn-block"
                                                                                                type="submit"
                                                                                                disabled={isLoading}
                                                                                            >
                                                                                                {isLoading ?
                                                                                                    <LoaderHorizontal/> : 'Сделать полное видео!'}
                                                                                            </Button>
                                                                                        </Form>

                                                                                        <div className={'payment-form-container'}
                                                                                             dangerouslySetInnerHTML={{__html: paymentFromHtml}}
                                                                                        ></div>

                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                        : ''
                                            }
                                        </div>
                                    )
                                    :
                                    (
                                        <div>
                                            {
                                                makerData.slidesNumReady === 0 ?
                                                    <div>
                                                        <div className="row justify-content-center">
                                                            <div className={'col-md-6 mt-5'}>
                                                                <p className={'preview-header'}>Необходимо добавить
                                                                                                слайды</p>
                                                                <Button
                                                                    onClick={() => {
                                                                        onGotoSlidesTab();
                                                                    }}>
                                                                    Добавить слайды
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div> : ''
                                            }
                                            {
                                                makerData.slidesNumReady >= 1 && makerData.slidesNumReady <= 2 ?
                                                    <div>
                                                        <div className="row justify-content-center">
                                                            <div className={'col-md-6 mt-5'}>
                                                                <p className={'preview-header'}>Добавьте ещё слайды</p>
                                                                <Button
                                                                    onClick={() => {
                                                                        onGotoSlidesTab();
                                                                    }}>
                                                                    Добавить слайды
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div> : ''
                                            }
                                            {
                                                makerData.slidesNumReady > MAX_SLIDES ?
                                                    <div>
                                                        <div className="row justify-content-center">
                                                            <div className={'col-md-6 mt-5'}>
                                                                <p className={'preview-header'}>Можно добавить не более
                                                                    {MAX_SLIDES} слайдов</p>
                                                                <Button
                                                                    onClick={() => {
                                                                        onGotoSlidesTab();
                                                                    }}>
                                                                    Удалить лишние слайды
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div> : ''
                                            }
                                        </div>
                                    )
                            }
                        </div>
                    )
                    :
                    (
                        <div>
                            {
                                !makerData.isAllPhotosUploaded ?
                                    (
                                        <div>
                                            <div className="wait-all-photos-load row justify-content-center">
                                                <div className={'col-md-6 mt-5'}>
                                                    <p className={'preview-header'}>Ещё не все фотографии
                                                        загружены. <br/>
                                                        Ждём,
                                                        пока {numSidesUploading}&nbsp;
                                                        {pluralize(numSidesUploading, 'фотографий загрузятся', 'фотография загрузится', 'фотографии загрузятся', 'фотографий загрузятся')}&nbsp;
                                                        полностью.
                                                    </p>
                                                    <Loader
                                                        isPositionAbsolute={false}
                                                        showBall={false}
                                                        showProgress={true}
                                                        progress={
                                                            Math.round(
                                                                makerData.slides.filter(s => s.type === 'text' || s.type === 'photo')
                                                                    .reduce(function (a, b) {
                                                                        return a + (b?.uploadProgress || 100);
                                                                    }, 0) / makerData.slides.filter(s => s.type === 'text' || s.type === 'photo').length
                                                            )
                                                        }
                                                        isLoaded={false}
                                                        background={'#fff'}/>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>
                                            {
                                                !makerData.isAllMusicUploaded ?
                                                    (
                                                        <div>
                                                            <div className="wait-all-photos-load row justify-content-center">
                                                                <div className={'col-md-6 mt-5'}>
                                                                    <p className={'preview-header'}>Ждём, пока мелодия полностью загрузится.</p>
                                                                    <Loader
                                                                        isPositionAbsolute={false}
                                                                        showBall={false}
                                                                        showProgress={true}
                                                                        progress={100}
                                                                        isLoaded={false}
                                                                        background={'#fff'}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    : ''
                                            }
                                        </div>
                                    )
                            }
                        </div>
                    )
            }
        </div>
    )
}

export default Payment;